<template>
	<modal-box @close="onModalClose" header="Add new payment method">
		<form @submit.prevent="validateAndSubmit" class="form-inline">
			<input-text v-model="model.name" name="card_name" placeholder="Name" rules="required"/>
			<input-text v-model="model.description" name="card_description" placeholder="Description"/>
			<div class="form-group">
				<label>Card</label>
				<div class="form-control card">
					<div id="card-element" class="grid-area-card"></div>
				</div>
			</div>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="loading" icon="save">Add</button-submit-icon-text>
			</div>
		</form>
		<error-popup v-if="error" title="Error" :text="error" @close="onErrorClose"/>
	</modal-box>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			loading: false,
			stripe: null,
			card: null,
			error: null,
			model: {
				name: '',
				description: ''
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.createToken()
			})
		},
		createToken () {
			this.loading = true
			const promise = this.stripe.createToken(this.card)
			promise.then(result => {
				if (result.token) {
					this.$log.info('payment methods', 'stripe.createToken OK', result)()
					this.addCard(result.token)
				}
				if (result.error) {
					this.$log.error('payment methods', 'stripe.createToken ERROR', result)()
					this.error = result.error.message
					this.loading = false
				}
			})
		},
		addCard (token) {
			this.loading = true
			const model = {
				method_id: token.card.id,
				source_id: token.id,
				...this.model
			}
			this.$api.subscriptions.paymentMethods.add(this, this.user_uid, model).then(response => {
				this.$log.info('payment methods', 'subscriptions.paymentMethods.add OK', response)()
				this.card.clear()
				this.$emit('success')
			}).catch(error => {
				this.$log.error('payment methods', 'subscriptions.paymentMethods.add ERROR', error)()
			}).finally(() => {
				this.loading = false
			})
		},
		onErrorClose () {
			this.error = null
		},
		onModalClose () {
			this.$emit('close')
		},
	},
	mounted () {
		const style = {
			base: {
				color: '#32325d',
				//padding: '5px',
				fontSize: '16px',
				'::placeholder': {
					color: '#aab7c4'
				}
			},
			invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			}
		}
		this.stripe = Stripe(this.$root.settings.stripePK)
		const elements = this.stripe.elements()
		this.card = elements.create('card', { style })
		this.card.mount('#card-element')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/PaymentMethodForm.vue